import { render, staticRenderFns } from "./helgesleben.vue?vue&type=template&id=a2145d56&scoped=true&"
import script from "./helgesleben.vue?vue&type=script&lang=js&"
export * from "./helgesleben.vue?vue&type=script&lang=js&"
import style0 from "./helgesleben.vue?vue&type=style&index=0&id=a2145d56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2145d56",
  null
  
)

export default component.exports